import React, { useState } from 'react';
import './Career.css';
import { SERVICE_CATEGORIES } from '../data/content';

const DEPT_MAP = {
  'pcb-hardware': 'PCB Division',
  'chip-asic': 'Chip & ASIC',
  'it-software': 'IT Software Services',
  'mechanical': 'Mechanical',
  'wiring-harness': 'Wiring Harness',
};

const OPEN_ROLES = [
  { title: 'ATE Board Design Engineer', dept: 'PCB Division', type: 'Full Time', location: 'Coimbatore, India', exp: '2–5 Years', skills: [], desc: 'Design and develop ATE boards for semiconductor test environments.' },
  { title: 'High-Speed PCB Designer', dept: 'PCB Division', type: 'Full Time', location: 'Coimbatore, India', exp: '3–6 Years', skills: [], desc: 'Design high-speed, high-density PCBs with signal integrity focus.' },
  { title: 'RF PCB Design Engineer', dept: 'PCB Division', type: 'Full Time', location: 'Coimbatore, India', exp: '2–5 Years', skills: [], desc: 'Design RF and microwave PCBs for telecommunications and defense.' },
  { title: 'ASIC Verification Engineer', dept: 'Chip & ASIC', type: 'Full Time', location: 'Coimbatore, India', exp: '2–5 Years', skills: [], desc: 'Perform functional and formal verification of ASIC designs.' },
  { title: 'Signal Integrity Engineer', dept: 'Chip & ASIC', type: 'Full Time', location: 'Coimbatore, India', exp: '3–6 Years', skills: [], desc: 'Analyze and resolve signal and power integrity issues in PCB designs.' },
  { title: 'Mechanical Design Engineer', dept: 'Mechanical', type: 'Full Time', location: 'Coimbatore, India', exp: '2–5 Years', skills: [], desc: 'Design mechanical enclosures and assemblies for electronic products.' },
  { title: 'Web Application Developer', dept: 'IT Software Services', type: 'Full Time', location: 'Coimbatore, India', exp: '1–3 Years', skills: [], desc: 'Build and maintain web applications for internal and client-facing projects.' },
  { title: 'EDA Tools Engineer', dept: 'PCB Division', type: 'Full Time', location: 'Coimbatore, India', exp: '2–4 Years', skills: [], desc: 'Manage EDA tool infrastructure, licensing, and PCB library development.' },
];

const PERKS = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
    title: 'Fast-Track Growth',
    desc: 'Work on cutting-edge PCB and semiconductor projects that accelerate your career at every stage.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    title: 'Global Exposure',
    desc: 'Collaborate with clients and engineers across USA, Japan, Singapore, and India on real-world projects.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </svg>
    ),
    title: 'Learning Culture',
    desc: 'Continuous upskilling with EDA tools, design standards and industry certifications every quarter.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'Equal Opportunity',
    desc: 'Every engineer is valued equally — from fresh graduates to senior veterans across all functions.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    title: 'Innovation First',
    desc: 'We encourage bold ideas and give engineers the freedom to solve real problems independently.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
    title: 'Flexible Work',
    desc: 'Flexible hours with a collaborative team that supports each other across time zones globally.',
  },
];

const TABS = ['All', ...new Set(OPEN_ROLES.map(r => r.dept))];

const TESTIMONIALS = [
  {
    name: 'Alex J.',
    role: 'Sr. PCB Design Engineer',
    years: '4 Years at DWB',
    text: 'Working at DWB has given me exposure to some of the most complex ATE board designs in the industry. The leadership trusts you with real challenges from day one.',
  },
  {
    name: 'Ram E.',
    role: 'ASIC Verification Lead',
    years: '6 Years at DWB',
    text: 'The culture here is truly collaborative. I grew from a fresh engineer to leading a verification team of 8 people — DWB invests in your growth seriously.',
  },
  {
    name: 'Karthik M.',
    role: 'Signal Integrity Engineer',
    years: '3 Years at DWB',
    text: 'The exposure to global clients and diverse projects has accelerated my learning more than any other role I could have taken. Proud to be part of this team.',
  },
];

/* ══════════════════════════════════════
   VALIDATION HELPERS (frontend)
══════════════════════════════════════ */
function isValidEmailFormat(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
}

function containsBlockedLinks(text) {
  const urlPattern = /https?:\/\/(?!(?:www\.)?linkedin\.com)[^\s]+|www\.(?!linkedin\.com)[^\s]+\.[a-z]{2,}/gi;
  return urlPattern.test(text);
}

export default function Career() {
  const [activeTab, setActiveTab] = useState('All');
  const [openIdx, setOpenIdx] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', role: '', message: '', resume: null });
  const [formErrors, setFormErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const toggle = (i) => setOpenIdx(prev => prev === i ? null : i);

  const filtered = activeTab === 'All'
    ? OPEN_ROLES
    : OPEN_ROLES.filter(r => r.dept === activeTab);

  /* ── Email blur validation ── */
  const handleEmailBlur = () => {
    if (formData.email && !isValidEmailFormat(formData.email)) {
      setFormErrors(er => ({ ...er, email: 'Please enter a valid email address (e.g. name@domain.com)' }));
    }
  };

  /* ── Field change handler ── */
  const handleFieldChange = (field, value) => {
    setFormData(p => ({ ...p, [field]: value }));
    // Live link check on message
    if (field === 'message' && containsBlockedLinks(value)) {
      setFormErrors(er => ({ ...er, message: 'Links are not allowed in the cover message. Only LinkedIn profile URLs are permitted.' }));
    } else if (formErrors[field]) {
      setFormErrors(er => ({ ...er, [field]: '' }));
    }
  };

  /* ── Frontend validation before submit ── */
  const validateForm = () => {
    const e = {};
    if (!formData.name.trim()) e.name = 'Full name is required';
    if (!formData.email.trim()) {
      e.email = 'Email address is required';
    } else if (!isValidEmailFormat(formData.email)) {
      e.email = 'Please enter a valid email address (e.g. name@domain.com)';
    }
    if (!formData.role) e.role = 'Please select a position';
    if (formData.message && containsBlockedLinks(formData.message)) {
      e.message = 'Links are not allowed in the cover message. Only LinkedIn profile URLs are permitted.';
    }
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length) { setFormErrors(errors); return; }

    setLoading(true);

    const formPayload = new FormData();
    formPayload.append('name', formData.name);
    formPayload.append('email', formData.email);
    formPayload.append('role', formData.role);
    formPayload.append('message', formData.message);
    if (formData.resume) formPayload.append('resume', formData.resume);

    try {
      const res = await fetch('http://localhost:5000/api/apply', {
        method: 'POST',
        body: formPayload,
      });
      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else if (data.error === 'invalid_email_format' || data.error === 'invalid_email_domain') {
        setFormErrors(er => ({ ...er, email: data.message }));
      } else if (data.error === 'blocked_link') {
        setFormErrors(er => ({ ...er, message: data.message }));
      } else {
        alert('Failed to submit. Please try again.');
      }
    } catch (err) {
      alert('Server error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="career" className="career-section">

      {/* ── HERO ── */}
      <div className="career-hero">
        <div className="career-hero-bg" />
        <div className="career-hero-overlay" />
        <div className="career-hero-content">
          <div className="career-hero-tag"> Join Our Team</div>
          <h1 className="career-hero-title">
            Great Ideas Start With<br />
            <span className="career-hero-accent">Great People</span>
          </h1>
          <p className="career-hero-sub">
            At DWB Tech, we're always looking for passionate engineers who want to work on
            world-class PCB design, ASIC verification, and cutting-edge semiconductor solutions.
          </p>
          <div className="career-hero-actions">
            <a href="#career-openings" className="career-btn career-btn--primary">
              View Open Positions
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </a>
            <a href="#career-apply" className="career-btn career-btn--ghost">
              Send Your CV
            </a>
          </div>
        </div>

        <div className="career-hero-stats">
          {[
            { val: '50+', label: 'Engineers Worldwide' },
            { val: '4', label: 'Global Locations' },
            { val: '32+', label: 'Years of Excellence' },
            { val: '98%', label: 'Retention Rate' },
          ].map(s => (
            <div key={s.label} className="career-stat">
              <div className="career-stat-val">{s.val}</div>
              <div className="career-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── WHAT WE OFFER ── */}
      <div className="career-offer">
        <div className="career-inner">
          <div className="career-offer-header">
            <div className="career-tag-line"> What We Offer</div>
            <h2 className="career-section-title">A Chance To Redefine <span className="career-gradient-text">Your Journey</span></h2>
            <p className="career-section-sub">Join a team of passionate engineers working on groundbreaking global projects.</p>
          </div>
          <div className="career-offer-tabs">
            <div className="career-offer-tab-btns">
              {['Early Careers', 'Experienced Professionals'].map((tab, i) => (
                <button
                  key={tab}
                  className={`career-offer-tab-btn${i === 0 ? ' active' : ''}`}
                  onClick={e => {
                    document.querySelectorAll('.career-offer-tab-btn').forEach(b => b.classList.remove('active'));
                    document.querySelectorAll('.career-offer-tab-panel').forEach(p => p.classList.remove('active'));
                    e.target.classList.add('active');
                    document.querySelectorAll('.career-offer-tab-panel')[i].classList.add('active');
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="career-offer-tab-panel active">
              <div className="career-offer-panel-content">
                <div className="career-offer-text">
                  <h3>Jumpstart Your Career</h3>
                  <p>Are you looking to jumpstart your career and unlock your potential? At DWB Tech, we know the importance of investing in our engineers and empowering them to reach new heights.</p>
                  <p>We recognize the unique talents of every engineer. We believe that diversity and inclusion are key ingredients to a successful workplace — fostering collaboration, creativity, and innovation.</p>
                  <a href="#career-apply" className="career-btn career-btn--primary" style={{ marginTop: '1.5rem', display: 'inline-flex' }}>Apply Now →</a>
                </div>
                <div className="career-offer-visual">
                  <div className="career-offer-visual-card">
                    <div className="career-offer-visual-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4a90d9" strokeWidth="1.8"><path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" /></svg>
                    </div>
                    <div className="career-offer-visual-stat">
                      <span className="career-offer-stat-val">6</span>
                      <span className="career-offer-stat-label">Open Roles</span>
                    </div>
                    <div className="career-offer-visual-divider" />
                    <div className="career-offer-visual-stat">
                      <span className="career-offer-stat-val">3</span>
                      <span className="career-offer-stat-label">Departments</span>
                    </div>
                    <div className="career-offer-visual-divider" />
                    <div className="career-offer-visual-stat">
                      <span className="career-offer-stat-val">100%</span>
                      <span className="career-offer-stat-label">Growth Focus</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="career-offer-tab-panel">
              <div className="career-offer-panel-content">
                <div className="career-offer-text">
                  <h3>Grow With Purpose</h3>
                  <p>We are looking for confident, globally-minded professionals to join our strong team. We work with international customers across diverse electronics industries.</p>
                  <p>You would be part of a team that creates innovative solutions for the future — with opportunities to learn future technologies, innovative practices, and leadership skills.</p>
                  <a href="#career-openings" className="career-btn career-btn--primary" style={{ marginTop: '1.5rem', display: 'inline-flex' }}>View Open Roles →</a>
                </div>
                <div className="career-offer-visual">
                  <div className="career-offer-visual-card">
                    <div className="career-offer-visual-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4a90d9" strokeWidth="1.8"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
                    </div>
                    <div className="career-offer-visual-stat">
                      <span className="career-offer-stat-val">31+</span>
                      <span className="career-offer-stat-label">Years Legacy</span>
                    </div>
                    <div className="career-offer-visual-divider" />
                    <div className="career-offer-visual-stat">
                      <span className="career-offer-stat-val">500+</span>
                      <span className="career-offer-stat-label">Projects Done</span>
                    </div>
                    <div className="career-offer-visual-divider" />
                    <div className="career-offer-visual-stat">
                      <span className="career-offer-stat-val">4</span>
                      <span className="career-offer-stat-label">Countries</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── PERKS ── */}
      <div className="career-perks">
        <div className="career-inner">
          <div className="career-tag-line">Work Benefits</div>
          <h2 className="career-section-title">Perks Of Being At <span className="career-gradient-text">DWB Tech</span></h2>
          <div className="career-perks-grid">
            {PERKS.map(p => (
              <div key={p.title} className="career-perk-card">
                <div className="career-perk-icon">{p.icon}</div>
                <h3 className="career-perk-title">{p.title}</h3>
                <p className="career-perk-desc">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── TESTIMONIALS ── */}
      <div className="career-testimonials">
        <div className="career-inner">
          <div className="career-tag-line">Voice Of DWB Engineers</div>
          <h2 className="career-section-title">Their Point Of View On <span className="career-gradient-text">Work & Growth</span></h2>
          <div className="career-testimonials-grid">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={t.name}
                className={`career-testimonial-card${activeTestimonial === i ? ' active' : ''}`}
                onClick={() => setActiveTestimonial(i)}
              >
                <div className="career-testimonial-quote">"</div>
                <p className="career-testimonial-text">{t.text}</p>
                <div className="career-testimonial-author">
                  <div className="career-testimonial-avatar">
                    {t.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <div className="career-testimonial-name">{t.name}</div>
                    <div className="career-testimonial-role">{t.role}</div>
                    <div className="career-testimonial-years">{t.years}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── OPEN POSITIONS ── */}
      <div className="career-openings" id="career-openings">
        <div className="career-inner">
          <div className="career-tag-line"> Current Openings</div>
          <h2 className="career-section-title">We Are Ready For You. <span className="career-gradient-text">Are You Too?</span></h2>
          <p className="career-section-sub">
            Don't see a perfect fit? Send your CV {' '}
            {' '}— we're always growing.
          </p>

          <div className="career-filter-tabs">
            {TABS.map(tab => (
              <button
                key={tab}
                className={`career-filter-btn${activeTab === tab ? ' active' : ''}`}
                onClick={() => { setActiveTab(tab); setOpenIdx(null); }}
              >
                {tab}
                <span className="career-filter-count">
                  {tab === 'All' ? OPEN_ROLES.length : OPEN_ROLES.filter(r => r.dept === tab).length}
                </span>
              </button>
            ))}
          </div>

          <div className="career-table">
            <div className="career-table-header">
              <span>Job Title</span>
              <span>Department</span>
              <span>Location</span>
              <span>Experience</span>
              <span></span>
            </div>
            {filtered.map((role, i) => (
              <div key={role.title} className={`career-table-row${openIdx === i ? ' open' : ''}`}>
                <div className="career-table-main" onClick={() => toggle(i)}>
                  <span className="career-table-title">{role.title}</span>
                  <span className="career-table-dept">
                    <span className="career-dept-dot" />
                    {role.dept}
                  </span>
                  <span className="career-table-loc">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
                    {role.location}
                  </span>
                  <span className="career-table-exp">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                    {role.exp}
                  </span>
                  <span className={`career-table-chevron${openIdx === i ? ' open' : ''}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6" /></svg>
                  </span>
                </div>

                {openIdx === i && (
                  <div className="career-table-body">
                    <p className="career-role-desc">{role.desc}</p>
                    <div className="career-role-skills">
                      {role.skills.map(s => (
                        <span key={s} className="career-skill">{s}</span>
                      ))}
                    </div>
                    <a href="#career-apply" className="career-btn career-btn--primary career-apply-btn"
                      onClick={e => e.stopPropagation()}>
                      Apply for this role →
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── APPLY FORM ── */}
      <div className="career-apply" id="career-apply">
        <div className="career-inner career-apply-inner">
          <div className="career-apply-text">
            <div className="career-tag-line">Apply Now</div>
            <h2 className="career-section-title">Ready To Join <span className="career-gradient-text">DWB Tech?</span></h2>
            <p className="career-apply-desc">
              Fill out the form and our HR team will get back to you within 48 hours.
              We review every application personally.
            </p>
          </div>

          <div className="career-form-wrap">
            {submitted ? (
              <div className="career-success">
                <div className="career-success-icon">
                  <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="9 12 11 14 15 10" /></svg>
                </div>
                <h3>Application Submitted!</h3>
                <p>Thank you! We'll review your application and get back to you within 48 hours.</p>
              </div>
            ) : (
              <form className="career-form" onSubmit={handleSubmit}>
                <div className="career-form-row">
                  <div className="career-form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      required
                      placeholder="John Smith"
                      style={formErrors.name ? { borderColor: '#ef4444' } : {}}
                      value={formData.name}
                      onChange={e => handleFieldChange('name', e.target.value)}
                    />
                    {formErrors.name && <span className="career-form-error" style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', display: 'block' }}>{formErrors.name}</span>}
                  </div>
                  <div className="career-form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      required
                      placeholder="john@company.com"
                      style={formErrors.email ? { borderColor: '#ef4444' } : {}}
                      value={formData.email}
                      onChange={e => handleFieldChange('email', e.target.value)}
                      onBlur={handleEmailBlur}
                    />
                    {formErrors.email && <span className="career-form-error" style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', display: 'block' }}>{formErrors.email}</span>}
                  </div>
                </div>

                <div className="career-form-group">
                  <label>Position Applying For *</label>
                  <select
                    required
                    style={formErrors.role ? { borderColor: '#ef4444' } : {}}
                    value={formData.role}
                    onChange={e => handleFieldChange('role', e.target.value)}
                  >
                    <option value="">Select a role...</option>
                    {OPEN_ROLES.map(r => (
                      <option key={r.title} value={r.title}>{r.title}</option>
                    ))}
                    <option value="other">Other / General Application</option>
                  </select>
                  {formErrors.role && <span className="career-form-error" style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', display: 'block' }}>{formErrors.role}</span>}
                </div>

                <div className="career-form-group">
                  <label>
                    Cover Message
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px',
                      marginLeft: '8px',
                      fontSize: '11px',
                      fontWeight: 500,
                      color: '#ef4444',
                    }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5">
                        <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                      </svg>
                      Only LinkedIn URLs allowed — no other links
                    </span>
                  </label>
                  <textarea
                    rows={4}
                    placeholder="Tell us about yourself and why you'd like to join DWB Tech…"
                    style={formErrors.message ? { borderColor: '#ef4444' } : {}}
                    value={formData.message}
                    onChange={e => handleFieldChange('message', e.target.value)}
                  />
                  {formErrors.message && <span className="career-form-error" style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', display: 'block' }}>{formErrors.message}</span>}
                </div>

                <div className="career-form-group">
                  <label>Upload Resume * <span style={{ fontWeight: 400, color: 'rgba(255,255,255,0.4)', fontSize: '11px' }}>(PDF, DOC, DOCX — max 5MB)</span></label>
                  <label className="career-file-upload">
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      style={{ display: 'none' }}
                      onChange={e => setFormData(p => ({ ...p, resume: e.target.files[0] || null }))}
                    />
                    <div className="career-file-upload-inner">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="17 8 12 3 7 8" />
                        <line x1="12" y1="3" x2="12" y2="15" />
                      </svg>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <span style={{ color: formData.resume ? '#4a90d9' : 'rgba(30,60,100,0.8)', fontWeight: 600, fontSize: '13px' }}>
                          {formData.resume ? formData.resume.name : 'Click to upload your resume'}
                        </span>
                        {!formData.resume && (
                          <span style={{ fontSize: '11px', color: 'rgba(30,60,100,0.5)' }}>
                            PDF, DOC, DOCX — max 5MB
                          </span>
                        )}
                      </div>
                    </div>
                  </label>
                </div>

                <button
                  type="submit"
                  className="career-btn career-btn--primary career-submit-btn"
                  disabled={loading}
                  style={loading ? { opacity: 0.75, cursor: 'not-allowed' } : {}}
                >
                  {loading ? (
                    <>
                      <svg
                        width="16" height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        style={{ animation: 'spin 0.8s linear infinite' }}
                      >
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                      </svg>
                      Submitting…
                    </>
                  ) : (
                    'Submit Application →'
                  )}
                </button>

                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* ── FAQ ── */}
      <div className="career-faq" id="faq">
        <div className="career-inner">
          <div className="career-tag-line">FAQ</div>
          <h2 className="career-section-title">Common <span className="career-gradient-text">Questions</span></h2>
          {[
            { q: 'What is the eligibility criteria to join DWB Tech?', a: 'BE/B.Tech in Electrical, Electronics & Communication, or Computer Science Engineering. We value fundamentals, communication skills, critical thinking, and the ability to work in a fast-paced engineering environment.' },
            { q: 'What is the selection process at DWB Tech?', a: 'Our process: (1) Resume screening, (2) Technical assessment, (3) Technical interview with a senior engineer, (4) HR discussion. The entire process typically takes 1–2 weeks.' },
            { q: "Can't find a role that matches your profile?", a: 'Send us your CV directly  with the subject line "General Application – [Your Specialization]". We regularly open new positions and will reach out when a suitable role opens.' },
          ].map((f, i) => (
            <div key={i} className={`career-faq-item${openFaq === i ? ' open' : ''}`} onClick={() => setOpenFaq(prev => prev === i ? null : i)}>
              <div className="career-faq-question">
                {f.q}
                <span className={`career-faq-chevron${openFaq === i ? ' open' : ''}`}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6" /></svg>
                </span>
              </div>
              {openFaq === i && <div className="career-faq-answer">{f.a}</div>}
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}